<template>
  <div
    id="container"
    class="d-flex justify-content-center align-items-center w-100"
  >
    <Logo />

    <form
      id="form"
      class="d-flex flex-column"
      style="transition: all 0.5s ease-in-out"
      @submit.prevent="enviarEmailRecuperarSenha"
    >
      <span>
        <h1
          style="
            font-style: normal;
            font-weight: 700;
            font-size: 34px;
            margin-bottom: 10px;
          "
        >
          Esqueceu sua senha?
        </h1>
        <p
          style="
            color: var(--grey-medium);
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            margin-bottom: 0;
            max-width: 329px;
          "
        >
          {{ subTitle }}
        </p>
      </span>
      <section class="mt-5">
        <div v-if="!isConfirmed" class="d-flex flex-wrap align-items-center">
          <img
            :src="require('@/assets/images/svg/ícone-carta.svg')"
            alt=""
            style="margin: 10px"
          />
          <span class="d-flex flex-column align-items-start">
            <p
              style="
                color: var(--black-medium);
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                margin-bottom: 0;
              "
            >
              Email
            </p>
            <p
              style="
                color: var(--grey-medium);
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                margin-bottom: 0;
              "
            >
              Confirme seu e-mail
            </p>
          </span>
        </div>
        <div
          v-if="!isConfirmed"
          class="w-100 d-flex justify-content-between align-items-center mt-3"
        >
          <div
            style="
              background-color: var(--grey-light);
              height: 42px;
              border-radius: 4px;
            "
            class="w-100 d-flex justify-content-between align-items-center"
          >
            <input
              class="border-0 w-100"
              style="
                outline: none;
                padding-left: 18px;
                font-size: 12px;
                background-color: transparent;
                height: 100%;
              "
              v-model="email"
              type="email"
              name="email"
              id="email"
              placeholder="Insira seu e-mail"
              @keyup="isValid()"
              required
            />
            <div v-if="email.length > 0">
              <img
                v-if="!isOk"
                :src="require('@/assets/images/svg/ícone-não-valido.svg')"
                style="margin-right: 18px"
                alt=""
              />
              <img
                v-else
                style="margin-right: 18px"
                :src="require('@/assets/images/svg/ícone-valido.svg')"
                alt=""
              />
            </div>
          </div>

          <button
            class="border-0"
            type="submit"
            style="
              border-radius: 4px;
              background-color: var(--lilac);
              height: 42px;
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              color: var(--white);
              text-align: center;
              width: 58px;
              margin-left: 8px;
            "
          >
            Ir
          </button>
        </div>
        <div
          class="d-flex justify-content-center align-items-center w-100 mt-5"
        >
          <router-link
            :class="isConfirmed ? 'btnBackColor' : 'btnBackColorless btn'"
            style=""
            :to="{ name: 'Login' }"
          >
            Voltar
          </router-link>
        </div>
      </section>
    </form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Logo from "@/components/Logo.vue";

export default {
  name: "ForgotPassword.vue",
  components: { Logo },
  data() {
    return {
      email: "",
      isOk: true,
      status: "",
      subTitle: "",
      isConfirmed: false,
    };
  },
  mounted() {
    this.subTitle = `Sem problemas, siga os passos abaixo pra recuperar! Por segurança,
        precisamos confirmar sua identidade.`;
  },
  methods: {
    ...mapActions(["forgotPassword"]),

    enviarEmailRecuperarSenha() {
      try {
        const response = this.forgotPassword(this.email);

        this.subTitle = `Caso o e-mail informado esteja em nossa base de dados, você receberá uma mensagem com as instruções
        para recuperação da sua senha. Fique de olho na caixa de spam.`;

        this.isConfirmed = true;
      } catch (error) {
        console.log(error);
      }
      // return this.$router.push({ name: "x" });
    },
    isValid() {
      let isValidEmail = document.getElementById("email").validity.valid;

      this.isOk = isValidEmail;
    },
  },
};
</script>
<style scoped>
#form {
  max-width: 513px;
  background-color: var(--white);
  border-radius: 16px;
  padding: 54px;
}
.btnBackColorless,
.btnBackColor {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
  outline: none;
  border: 0;
}
.btnBackColorless {
  color: var(--blue-medium);
}
.btnBackColor {
  width: 100%;
  text-align: center;
  color: var(--white);
  background-color: var(--blue-medium);
  padding: 18px 0;
  border-radius: 8px;
}
#logo {
  left: 24px;
  top: 64px;
  position: absolute;
}
@media only screen and (max-width: 764px) {
  #logo {
    left: 0;
    top: 0;
    position: initial;
    margin-top: 10px;
  }
}
@media only screen and (max-width: 800px) {
  #form {
    padding: 30px;
    margin: 20px;
  }
}
</style>
